// Ian - Toggles footer menu accordions on mobile

document.addEventListener('DOMContentLoaded', () => {
  const footerAccordionBlocks = document.querySelectorAll('.footer-accordion-block');

  if (!footerAccordionBlocks.length) return;

  footerAccordionBlocks.forEach((block) => {
    const toggle = block.querySelector('.footer-accordion-toggle');
    const content = block.querySelector('.footer-accordion-content');

    if (!toggle || !content) return;

    const toggleAccordion = () => {
      const isOpen = block.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    toggle.addEventListener('click', toggleAccordion);

    toggle.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      toggleAccordion();
    });
  });
});